import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { Lock as LockIcon, Check } from 'lucide-react';
function useCountdown(hours: number) {
  const [timeLeft, setTimeLeft] = useState(hours * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(t => t > 0 ? t - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const h = String(Math.floor(timeLeft / 3600)).padStart(2, '0');
  const m = String(Math.floor(timeLeft % 3600 / 60)).padStart(2, '0');
  const s = String(timeLeft % 60).padStart(2, '0');
  return {
    h,
    m,
    s
  };
}
const benefits = ['Protocolo Clínico de 21 Días', 'Guía de Alimentos Prohibidos (Bonus)', 'Lista de Compra Inteligente (Bonus)'];
export function PricingClose() {
  const {
    h,
    m,
    s
  } = useCountdown(48);
  return <section id="pricing" className="py-24 md:py-44 bg-sage-dark/30 scroll-mt-20" data-id="element-112">
      <div className="container mx-auto px-4 sm:px-6 max-w-2xl" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl px-5 py-12 sm:px-8 sm:py-14 md:px-16 md:py-20 shadow-xl shadow-forest/5 border border-sage text-center relative overflow-hidden" data-id="element-114">
          {/* Discount Sticker — vibrant orange seal */}
          <motion.div initial={{
          rotate: -12,
          scale: 0,
          opacity: 0
        }} whileInView={{
          rotate: -12,
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 180,
          delay: 0.4
        }} className="absolute top-4 right-4 md:top-8 md:right-8 w-16 h-16 md:w-24 md:h-24 bg-[#FF6B35] text-white rounded-full flex flex-col items-center justify-center shadow-xl shadow-[#FF6B35]/40 border-2 border-white ring-2 ring-[#FF6B35]/30" data-id="element-115">
            <span className="text-xl md:text-3xl font-black leading-none tracking-tight" data-id="element-116">
              80%
            </span>
            <span className="text-[9px] md:text-xs font-bold tracking-[0.2em] mt-0.5 md:mt-1" data-id="element-117">
              DTO
            </span>
          </motion.div>

          {/* Eyebrow */}
          <div className="text-[11px] font-semibold text-forest/60 tracking-[0.25em] uppercase mb-10" data-id="element-118">
            Oferta de Lanzamiento
          </div>

          {/* Benefits list */}
          <ul className="flex flex-col items-center gap-3 mb-12 max-w-sm mx-auto" data-id="element-119">
            {benefits.map((b, i) => <li key={i} className="flex items-center gap-3 text-sm md:text-base text-forest font-medium text-left w-full" data-id="element-120">
                <span className="w-6 h-6 rounded-full bg-sage flex items-center justify-center shrink-0" data-id="element-121">
                  <Check className="w-3.5 h-3.5 text-forest" strokeWidth={3} data-id="element-122" />
                </span>
                <span data-id="element-123">{b}</span>
              </li>)}
          </ul>

          {/* PRICE — King of the page */}
          <div className="flex items-start justify-center gap-2 sm:gap-4 mb-4 px-2" data-id="element-124">
            <span className="text-base sm:text-xl md:text-2xl text-forest/25 font-medium line-through pt-4 sm:pt-6 md:pt-10" data-id="element-125">
              49,90€
            </span>
            <span className="text-[4.5rem] sm:text-[6rem] md:text-[10rem] font-black tracking-[-0.05em] text-forest leading-none whitespace-nowrap" data-id="element-126">
              9,90€
            </span>
          </div>

          {/* Countdown — urgent amber-tinted block */}
          <div className="inline-flex flex-col items-center gap-2.5 bg-[#FFF4EC] border border-[#FF6B35]/25 rounded-xl px-4 sm:px-6 py-3 sm:py-4 mt-6 sm:mt-8 mb-10 sm:mb-12 shadow-sm" data-id="element-127">
            <span className="text-[10px] font-bold text-[#FF6B35] tracking-[0.25em] uppercase flex items-center gap-1.5" data-id="element-128">
              <span className="relative flex h-1.5 w-1.5" data-id="element-129">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#FF6B35] opacity-75" data-id="element-130"></span>
                <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#FF6B35]" data-id="element-131"></span>
              </span>
              Termina en
            </span>
            <div className="flex items-center gap-2 sm:gap-3" data-id="element-132">
              {[{
              v: h,
              l: 'h'
            }, {
              v: m,
              l: 'm'
            }, {
              v: s,
              l: 's'
            }].map((u, i) => <Fragment key={u.l} data-id="element-133">
                  <div className="flex items-baseline gap-0.5 sm:gap-1" data-id="element-134">
                    <span className="text-xl sm:text-2xl md:text-3xl font-bold tabular-nums text-forest leading-none font-mono" data-id="element-135">
                      {u.v}
                    </span>
                    <span className="text-[10px] sm:text-xs font-semibold text-forest/40 uppercase" data-id="element-136">
                      {u.l}
                    </span>
                  </div>
                  {i < 2 && <span className="text-forest/15 font-light" data-id="element-137">·</span>}
                </Fragment>)}
            </div>
          </div>

          {/* Tight pre-CTA line */}
          <p className="text-base md:text-lg text-forest font-semibold mb-5 tracking-tight" data-id="element-138">
            Ahorras 40€ hoy
          </p>

          {/* THE BUTTON */}
          <motion.a href="https://vyralea.com/cart/55754971611476:1?checkout" whileHover={{
          scale: 1.015,
          y: -2
        }} whileTap={{
          scale: 0.985,
          y: 0
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 20
        }} id="buy" className="block w-full bg-forest text-white px-4 py-6 sm:px-8 sm:py-8 md:py-10 rounded-full text-sm sm:text-lg md:text-2xl font-bold uppercase tracking-tight hover:bg-forest/90 transition-[background-color,box-shadow] shadow-xl shadow-forest/25 hover:shadow-2xl hover:shadow-forest/45 mb-4 scroll-mt-24 text-center" data-id="element-139">
            QUIERO MI RESET POR 9,90€
          </motion.a>

          {/* Social proof under CTA */}
          <p className="text-sm text-forest/70 font-medium mb-1.5 tracking-tight" data-id="element-140">
            Únete a otras +2.400 mujeres que ya han recuperado su ligereza
          </p>

          {/* Pago info */}
          <p className="text-xs text-forest/45 font-medium mb-6 tracking-tight" data-id="element-141">
            Pago único · Acceso para siempre
          </p>

          {/* Guarantee line */}
          <p className="text-xs md:text-[13px] text-forest/65 font-semibold mb-4 tracking-tight" data-id="element-142">
            🛡️ Garantía de satisfacción de 30 días o te devolvemos tu dinero
          </p>

          {/* Payment logos row — minimal, light gray */}
          <div className="flex flex-wrap items-center justify-center gap-2 opacity-75" data-id="element-143">
            <div className="h-6 px-2 rounded bg-white border border-forest/10 flex items-center justify-center text-[9px] font-black tracking-tight text-forest/50" data-id="element-144">
              VISA
            </div>
            <div className="h-6 px-1.5 rounded bg-white border border-forest/10 flex items-center justify-center gap-0.5" data-id="element-145">
              <span className="w-2.5 h-2.5 rounded-full bg-forest/30" data-id="element-146"></span>
              <span className="w-2.5 h-2.5 rounded-full bg-forest/20 -ml-1 mix-blend-multiply" data-id="element-147"></span>
            </div>
            <div className="h-6 px-2 rounded bg-white border border-forest/10 flex items-center justify-center text-[9px] font-black tracking-tight text-forest/50" data-id="element-148">
              PayPal
            </div>
            <span className="ml-1 inline-flex items-center gap-1 text-[10px] text-forest/40 font-medium" data-id="element-149">
              <LockIcon className="w-2.5 h-2.5" data-id="element-150" />
              <span data-id="element-151">SSL 256-bit</span>
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}